import { useDispatch } from "react-redux";
import { FaAngleDoubleLeft, FaHome, FaSignOutAlt } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { toggleSideNav } from '../../actions/SideNavActions';
import { useWolfTracsState } from '../../hooks/redux/useWolfTracsState';
import { useRouteMatch } from 'react-router-dom';
import { logout } from '../../actions/AccountActions';
import { EnrollmentWizardNavigator } from '../Enrollment/Wizard';
import { AuthWrapper } from "../AuthWrapper";

import './SideNav.scss';
import { Button, Col, Container, Row } from 'react-bootstrap';

const SideNav = () => {

    const { opened } = useWolfTracsState(s => s.sideNav);
    const account = useWolfTracsState(s => s.account);

    const dispatch = useDispatch();

    const match = useRouteMatch();

    const wrapperClassName = opened ? "side-menu opened" : "side-menu";

    return (
        <div className={wrapperClassName}>
            <div className="backdrop" onClick={() => dispatch(toggleSideNav())}></div>
                <div id="sidebar-menu">
                <Container className="sidebar-nav">
                    <Row>
                        <Col>
                            <Button onClick={() => dispatch(toggleSideNav())}><FaAngleDoubleLeft /> Close</Button>
                        </Col>
                    </Row>
                </Container>
                    {account.isAuthenticated && (
                        <ul className="side-bar-main">
                            <li>
                                <NavLink to="/" exact activeClassName="active">
                                    <FaHome /> Home
                                </NavLink>
                            </li>
                            <li>
                                <AuthWrapper 
                                    path={`${match.url}packages/:packageId`}
                                    render={() => (
                                        <ul>
                                            <EnrollmentWizardNavigator />
                                        </ul>
                                    )}
                                />
                            </li>
                            
                            <li>
                                <a href="#logout" onClick={(e) => {
                                    e.preventDefault();
                                    dispatch(logout());
                                }}><FaSignOutAlt /> Logout</a>
                            </li>
                        </ul>
                    )}
            </div>
        </div>
    );
};

export default SideNav;